import api from "./api"

export const checkToken = () => { 
  return api.get('/handle').then(res => res.data)
}